export function getDisplayReview({ deal }) {
  const merchant = deal?.merchantReviewRating || {};
  const summary = deal?.reviewSummary || {};

  // MR B group: implement the specified logic rules as mentioned in tkt
  const reviewTotal = summary?.total || 0;
  const reviewAverage = summary?.average || 0;
  const merchantAverage = merchant?.average || 0;

  // Rule 1: IF reviewSummary.total < 3 AND merchantReviewSummary.average >= 3.5 then,show merchant
  if (reviewTotal < 3 && merchantAverage >= 3.5) {
    return merchant;
  }

  // Rule 2: IF reviewSummary.total < 3 AND merchantReviewSummary.average < 3.5 THEN DON'T show
  if (reviewTotal < 3 && merchantAverage < 3.5) {
    return {};
  }

  // Rule 3: IF reviewSummary.total >= 3 AND reviewSummary.average < 3.5 AND merchantReviewSummary.average < 3.5 THEN DON'T show
  if (reviewTotal >= 3 && reviewAverage < 3.5 && merchantAverage < 3.5) {
    return {};
  }

  // Rule 4: IF reviewSummary.total >= 3 AND reviewSummary.average < 3.5 AND merchantReviewSummary.average >= 3.5 THEN show merchant
  if (reviewTotal >= 3 && reviewAverage < 3.5 && merchantAverage >= 3.5) {
    return merchant;
  }

  // Rule 5: IF reviewSummary.total >= 3 AND reviewSummary.average >= 3.5 THEN show deal review
  if (reviewTotal >= 3 && reviewAverage >= 3.5) {
    return summary;
  }

  return {};
}

export const classifyReviews = (reviews) => {
  if (!reviews || reviews?.length === 0) {
    return;
  }

  const dealReviews = reviews.filter((review) => review.currentDeal === true);
  const merchantReviews = reviews.filter(
    (review) => review.currentDeal === false,
  );

  if (dealReviews.length > 0 && merchantReviews.length > 0) {
    return 'both_reviews';
  } else if (dealReviews.length > 0 && merchantReviews.length === 0) {
    return 'deal_review_only';
  } else if (dealReviews.length === 0 && merchantReviews.length > 0) {
    return 'merchant_review_only';
  }
};
export const sortOptions = [
  { name: 'Rating (high to low)', value: 'rating' },
  { name: 'Most Recent', value: 'recent' },
];
